"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.semver = exports.comparator = void 0;
// @ts-ignore
const { compare } = new Intl.Collator(0, { numeric: 1 });
exports.comparator = (value, other) => {
    const a = value.split(".");
    const b = other.split(".");
    const hasSameMajor = compare(a[0], b[0]);
    if (hasSameMajor) {
        return hasSameMajor;
    }
    const hasSameMinor = compare(a[1], b[1]);
    if (hasSameMinor) {
        return hasSameMinor;
    }
    return compare(a.slice(2).join("."), b.slice(2).join("."));
};
const isEqual = (value, other) => exports.comparator(value, other) === 0;
const isGreaterThan = (value, other) => exports.comparator(value, other) === 1;
const isGreaterThanOrEqual = (value, other) => isGreaterThan(value, other) || isEqual(value, other);
const isLessThan = (value, other) => exports.comparator(value, other) === -1;
const isLessThanOrEqual = (value, other) => isLessThan(value, other) || isEqual(value, other);
exports.semver = {
    isEqual,
    isGreaterThan,
    isGreaterThanOrEqual,
    isLessThan,
    isLessThanOrEqual,
};
//# sourceMappingURL=semver.js.map